<template>
  <div class="kChart">
    <!-- 标的弹窗 -->
    <el-dialog
      title="权重比设置（需要相加等于100%）"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="weightVisible"
      width="600px"
      class="symbolDialog"
    >
      <ul class="digweigUl">
        <li v-for="(item,idx) in weightData" :key="idx">
          <span class="titleName"> {{item.factor_name}}</span>
          <el-input v-model="weights[idx]" placeholder="请输入" maxlength="3" onkeyup="value=value.replace(/[^\d]/g,'')"
           class="inNum"></el-input>%
        </li>
        <li class="blue" v-if="blueType">权重比设置（需要相加等于100%）</li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="save(false)"  class="btn" style="margin-right:14px;">取 消</el-button>
        <el-button type="primary" @click="save(true)" class="btn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    // 已选择数据
    weightData: {
      type: Array,
      required: true
    },
     // 设置权重
    listWeights: {
      type: Array,
      required: true
    },
    // 是否弹窗
    weightVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      blueType:false,
      weights: []
    };
  },
  methods: {
    // 保存
    save(type) {
      this.blueType = false;
      if(type){
        let sum = 0;
        this.weights.forEach((item,idx)=>{
          sum = sum+Number(item)  
        })
        if(sum != 100){
          this.blueType = true;
          return
        }
      }
      this.$emit('onSucceed',this.weights,type)
    },
    ngOnInit(){
        this.weights = [...this.listWeights];
    }
  },
  mounted() {},
  created() {}
};
</script>
<style lang="less" scoped>
// 弹窗
.blue{
  color: red;
  font-size: 12px;
}
.digweigUl {
  text-align: center;
  font-size: 14px;
  color: #666666;
  li{
    margin-bottom: 10px;
  }
  .titleName{
    display: inline-block;
    width: 200px;
  }
}
 .inNum {
    width: 90px;
    height: 30px;
    margin: 0 10px;
  }
  .inNum /deep/ .el-input__inner{
    width: 90px;
    height: 30px;
  }
.dialog-footer {
    text-align: center;
    .btn {
      width: 110px;
      height: 30px;
      padding: 0;
      margin: 0;
    }
  }
.symbolDialog {
  /deep/ .el-dialog__body {
    padding: 20px 0;
  }
  /deep/ .el-dialog__header {
    padding: 0;
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(87, 163, 239, 1);
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 4px 0px rgba(153, 153, 153, 1);
  }
  /deep/ .el-dialog__title {
    line-height: 24px;
    color: #57a3ef;
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }
}
</style>
